import type { ConfigGETResponseSuccess } from '@contracts'
import type { RegionsDetailDataV5 } from 'utils/utils.d'
import type { AutocompleteDefaultOption } from '@wppopen/components-library'
import type { RegionFormReducerState } from 'reducers/CreateAndEditRegionReducer/CreateAndEditRegionReducer'
import {
  emptySingleInputField,
  emptySelectField,
  emptyListField,
  errorAndWarningAttributes,
} from 'reducers/FormReducer/FormReducer'

// Hardcoded languages as per CMCST-607
export const supportedLanguages = new Map([
  ['bg_bg', 'Bulgarian'],
  ['cz_cs', 'Czech'],
  ['dk_da', 'Danish'],
  ['de_de', 'German'],
  ['gr_el', 'Greek'],
  ['gb_en', 'English (United Kingdom)'],
  ['us_en', 'English (United States)'],
  ['es_es', 'Spanish'],
  ['ee_et', 'Estonian'],
  ['fi_fi', 'Finnish'],
  ['fr_fr', 'French'],
  ['hu_hu', 'Hungarian'],
  ['id_id', 'Indonesian'],
  ['it_it', 'Italian'],
  ['jp_ja', 'Japanese'],
  ['kr_ko', 'Korean'],
  ['lt_lt', 'Lithuanian'],
  ['lv_lv', 'Latvian'],
  ['no_nb', 'Norwegian'],
  ['nl_nl', 'Dutch'],
  ['pl_pl', 'Polish'],
  ['br_pt', 'Portuguese (Brazil)'],
  ['pt_pt', 'Portuguese (Portugal)'],
  ['ro_ro', 'Romanian'],
  ['ru_ru', 'Russian'],
  ['sk_sk', 'Slovak'],
  ['si_sl', 'Slovenian'],
  ['se_sv', 'Swedish'],
  ['tr_tr', 'Turkish'],
  ['ua_uk', 'Ukrainian'],
  ['cn_zh', 'Chinese'],
  ['be_fr', 'French (Belgium)'],
  ['be_nl', 'Dutch (Belgium)'],
  ['ar_es', 'Spanish (Argentina)'],
  ['bo_es', 'Spanish (Bolivia)'],
  ['cl_es', 'Spanish (Chile)'],
  ['co_es', 'Spanish (Colombia)'],
  ['cr_es', 'Spanish (Costa Rica)'],
  ['do_es', 'Spanish (Dominican Republic)'],
  ['ec_es', 'Spanish (Ecuador)'],
  ['gt_es', 'Spanish (Guatemala)'],
  ['hn_es', 'Spanish (Honduras)'],
  ['mx_es', 'Spanish (Mexico)'],
  ['ni_es', 'Spanish (Nicaragua)'],
  ['pa_es', 'Spanish (Panama)'],
  ['pe_es', 'Spanish (Peru)'],
  ['pr_es', 'Spanish (Puerto Rico)'],
  ['py_es', 'Spanish (Paraguay)'],
  ['sv_es', 'Spanish (El Salvador)'],
  ['uy_es', 'Spanish (Uruguay)'],
  ['ve_es', 'Spanish (Venezuela)'],
])

export const transformRegionData = (
  regionData: RegionsDetailDataV5,
  configRetailers: ConfigGETResponseSuccess['retailers'],
): RegionFormReducerState => {
  const { name, locale, flag, retailers, config } = regionData

  return {
    name: {
      ...emptySingleInputField,
      value: name,
    },
    locale: {
      ...emptySelectField,
      value: locale,
    },
    flag: {
      ...emptySelectField,
      value: flag as string,
    },
    retailers: {
      value: retailers
        ? retailers?.map(id => {
            const retailer = configRetailers?.find(({ _id: retailerId }) => retailerId === id)
            return { label: retailer?.name || `unknown id: ${id}`, id: id } as AutocompleteDefaultOption
          })
        : [],
      type: 'autocomplete',
      ...errorAndWarningAttributes,
    },
    guidelines: {
      ...emptyListField,
      value: config?.guidelines || [],
    },
  }
}
